import createEnum from "../enum";
import { language } from "../../language/get";

//	直播间类型1直播间2论坛
const [RoomType] = createEnum([
  {
    name: language().oneTone,
    type: 1
  },
  {
    name: language().bbs,
    type: 2
  },
]);
export {RoomType}

const [LiveStateType] = createEnum([
  {
    name: language().enter,
    type: "1"
  },
  {
    name: language().leave,
    type: "2"
  }
]);
export {LiveStateType}